import { useState } from "react";
import { useHistory } from "react-router";
import { useAppContext } from "../../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../../controller/article/ArticleController";
import EnumReviewStatus from "../../../../utils/enum/EnumReviewStatus";
import { handleErrorMessage, useEffectOnce } from "../../../../utils/Utils";
import { useConfirm } from "material-ui-confirm";
import LabelsContext from "../../../../lang/LabelsContext";

interface ArticleDraftServiceType {
  articleDraftList: any;
  openSubmit: (id: number) => void;
  deleteArticleConfirm: (id: number) => void;
}

export default function ArticleDraftService(): ArticleDraftServiceType {
  const { axiosGetMyArticleWithStatus, axiosPostDeleteArticle }: ArticleControllerType = ArticleController();
  const { showMessage, setBlockUI, refreshSideMenuAction } = useAppContext();
  const [articleDraftList, setArticleDraftList] = useState<any>(undefined);

  const confirm = useConfirm();
  const { Labels } = LabelsContext();
  const history = useHistory();

  const fetchData = () => {
    setBlockUI(true);
    axiosGetMyArticleWithStatus([EnumReviewStatus.DRAFT])
      .then((result: any) => {
        setArticleDraftList(result.data);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      })
      .finally(() => setBlockUI(false));
  };

  useEffectOnce(() => fetchData());

  const openSubmit = (id: number) => history.push(`/manuscript/submit/${id}`);

  const deleteArticleConfirm = (id: number) => {
    confirm({
      description: "Are you sure you want delete draft?",
      confirmationText: Labels.YES,
      cancellationText: Labels.NO,
      confirmationButtonProps: {
        variant: "contained",
        color: "primary",
      },
    })
      .then(() => deleteArticle(id))
      .catch(() => {});
  };

  const deleteArticle = (id: number) => {
    setBlockUI(true);
    axiosPostDeleteArticle(id)
      .then((result: any) => {
        fetchData();
        refreshSideMenuAction();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      })
      .finally(() => setBlockUI(false));
  };

  return {
    articleDraftList,
    openSubmit,
    deleteArticleConfirm,
  };
}

export type { ArticleDraftServiceType };
